import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { getIsLoggedIn } from '@client/context/redux/redux';
import { fetchManufacturer, selectManufacturer } from '@client/manufacturer/redux/manufacturer/redux';
import { ManufacturerType } from 'b2b-common/core/manufacturer';

export const useManufacturerEffect = (
  manufacturerId: string,
): RemoteRecord<ManufacturerType> => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const manufacturer = useSelector(state => selectManufacturer(state, manufacturerId));

  useEffect(
    () => {
      dispatch(fetchManufacturer(manufacturerId));
    },
    [isLoggedIn, manufacturerId],
  );

  return manufacturer;
};
